import { Button } from "react-bootstrap";
import DatePicker from "../../components/DatePicker";
import TableContainer from "./TableContainer";
import { useEffect } from "react";
import { load_transactions_list } from "../../actions/payment_management";
import { useDispatch } from "react-redux";
import { checkAuthenticated } from "../../actions/auth";
import { tableHeaders } from "../../hooks/constants";
import { useState } from "react";
import { load_actives_list } from "../../actions/management_content";

const initial_filter_values = {
  year: 2025,
  month: 1,
  transaction_type: "",
  active_type: "",
  active_category: "",
  payment_type: "",
};
const TransactionsByFilter = ({ setModalsData }) => {
  const dispatch = useDispatch();
  const nowDate = new Date();

  const [dateValues, setDateValues] = useState({
    year: nowDate.getFullYear(),
    month: nowDate.getMonth() + 1,
  });
  const [filterValues, setFilterValues] = useState(initial_filter_values);

  const [activesList, setActivesList] = useState({
    service: [],
    product: [],
    rent: [],
    bank: [],
    salary: [],
    other: [],
  });
  const [transactionList, setTransactionList] = useState([]);
  const [filteredSummary, setFilteredSummary] = useState({
    total_ingreso: 0,
    total_egreso: 0,
    total_transactions: 0,
  });

  const fetchActivesList = async () => {
    dispatch(checkAuthenticated());
    const data = await load_actives_list();
    if (data) {
      setActivesList({ ...activesList, ...data });
    }
  };
  const fetchTransactionsByFilter = async () => {
    dispatch(checkAuthenticated());

    const { year, month } = dateValues;
    const filter_params = {
      ...filterValues,
      year,
      month,
    };
    if (!filterValues.active_type) {
      filter_params.active_category = null;
    }

    const data = await load_transactions_list(filter_params);
    if (data) {
      setTransactionList(data.results);
      setFilteredSummary({
        ...filteredSummary,
        ...data.totals,
        total_transactions: data.count,
      });
    }
  };

  const handleChangeFilter = (e) => {
    const path = e.target.name;
    setFilterValues((prevFilterValues) => {
      return { ...prevFilterValues, [path]: e.target.value };
    });
  };
  const handleSubmitFilters = (e) => {
    e.preventDefault();
    fetchTransactionsByFilter();
  };
  const handleTransactionEdit = (transactionId) => {
    setModalsData({
      transactionModalId: transactionId,
      transactionModalShow: true,
    });
  };

  const tableConfigActives = {
    headers: tableHeaders.transactionsTable,
    checkable: false,
    detailFunction: handleTransactionEdit,
    listData: transactionList,
    tableHeight: "table-height-5",
    // initialSort: "created",
    initialDirection: "desc"
  };
  useEffect(() => {
    fetchActivesList();
    fetchTransactionsByFilter();
  }, []);
  return (
    <div className="finance-filter-table">
      <div className="finance-filter-table-header">
        <h2>Filtrar por:</h2>
      </div>
      <div className="transaction-filters">
        <div className="dropdown-filters">
          <div className="filter-item">
            <h4>Fecha</h4>
            <DatePicker dateValues={dateValues} setDateValues={setDateValues} />
          </div>
          <div className="filter-item option">
            <h4>Ingreso/Egreso</h4>
            <select
              className="form-select year-select"
              aria-label="Year select"
              name="transaction_type"
              value={filterValues.transaction_type}
              onChange={(e) => handleChangeFilter(e)}
            >
              <option value="">Ambos</option>
              <option value="ingreso">Ingreso</option>
              <option value="egreso">Egreso</option>
            </select>
          </div>
          <div className="filter-item option">
            <h4>Tipo de activo</h4>
            <select
              className="form-select year-select"
              aria-label="Year select"
              name="active_type"
              value={filterValues.active_type}
              onChange={(e) => handleChangeFilter(e)}
            >
              <option value="">Todos</option>
              <option value="service">Servicio</option>
              <option value="product">Producto</option>
              <option value="rent">Arriendo</option>
              <option value="bank">Banco</option>
              <option value="salary">Remuneración</option>
              <option value="other">Otro</option>
            </select>
          </div>
          {filterValues.active_type && (
            <div className="filter-item option">
              <h4>Categoria</h4>
              <select
                className="form-select year-select"
                aria-label="Year select"
                name="active_category"
                value={filterValues.active_category}
                onChange={(e) => handleChangeFilter(e)}
              >
                <option value="">Todos</option>
                {activesList[filterValues.active_type]?.map((item) => (
                  <option value={item.id} key={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>
          )}
          <div className="filter-item option">
            <h4>Metodo de Pago</h4>
            <select
              className="form-select year-select"
              aria-label="Year select"
              name="payment_type"
              value={filterValues.payment_type}
              onChange={(e) => handleChangeFilter(e)}
            >
              <option value="">Todos</option>
              <option value="efectivo">Efectivo</option>
              <option value="transferencia">Transferencia</option>
              <option value="credito">Crédito</option>
              <option value="other">Otro</option>
            </select>
          </div>
        </div>
        <div className="submit-filters">
          <Button
            variant="primary d-flex align-items-center gap-2"
            onClick={(e) => handleSubmitFilters(e)}
          >
            Filtrar / Actualizar
          </Button>
        </div>
      </div>
      <div className="finance-tables-container">
        <TableContainer tableConfig={tableConfigActives} />
      </div>
      <div className="finance-tables-summary">
        <div className="finance-summary-header">
          <h4>Resumen Filtrado</h4>
        </div>
        <div className="finance-summary-content">
          <div className="card card-income">
            <h5>Total de ingreso:</h5>
            <div className="card-income-value">
              <span>${filteredSummary.total_ingreso}</span>
            </div>
          </div>
          <div className="card card-income">
            <h5>Total de egreso:</h5>
            <div className="card-income-value">
              <span>${filteredSummary.total_egreso}</span>
            </div>
          </div>
          <div className="card card-income">
            <h5>N° de transacciones:</h5>
            <div className="card-income-value">
              <span>{filteredSummary.total_transactions}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionsByFilter;
